import React from 'react';
import { PreKSettings } from '../PreKAssessment/types';
import PreKSelectionScreen from '../PreKAssessment/SelectionScreen';

interface SelectionScreenProps {
  onStart: (settings: PreKSettings) => void;
  currentTrack?: string;
}

const SelectionScreen: React.FC<SelectionScreenProps> = ({ onStart, currentTrack }) => {
  return <PreKSelectionScreen onStart={onStart} gradeLevel="K" currentTrack={currentTrack} />;
};

export default SelectionScreen;